import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=3e0b11ea&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=3e0b11ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0b11ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e0b11ea')) {
      api.createRecord('3e0b11ea', component.options)
    } else {
      api.reload('3e0b11ea', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=3e0b11ea&scoped=true&", function () {
      api.rerender('3e0b11ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hRhXQwKBxYHV/JS/comp/CookieBox.vue"
export default component.exports